import { ptBR } from '@mui/material/locale';
import { createTheme } from '@mui/material/styles';

const ProduttivoMuiThemeV2 = createTheme(
    {
        palette: {
            background: {
                default: '#FFF',
                header: '#FAFAFA',
            },
            text: {
                primary: '#212121',
                secondary: '#616161',
                disabled: '#9E9E9E',
            },
            primary: {
                main: '#018923',
                dark: '#005A00',
                light: '#23A937',
                contrastText: '#FFFFFF',
                hover: '#0189230A',
                selected: '#01892314',
                focus: '#0189231F',
                focusVisible: '#0189234D',
                outlinedBorder: '#0189234D',
            },
            success: {
                main: '#007817',
            },
            warning: {
                main: '#EF6C00',
            },
            info: {
                main: '#0288D1',
            },
            error: {
                main: '#C62828',
            },
            divider: '#0000001F',
            default: {
                main: '#FFF',
            },
        },
        typography: {
            h1: { fontSize: '6rem', fontWeight: 700, lineHeight: '116.7%' },
            h2: { fontSize: '3.75rem', fontWeight: 700, lineHeight: '120%' },
            h3: { fontSize: '3rem', fontWeight: 700, lineHeight: '116.7%' },
            h4: { fontSize: '2.125rem', fontWeight: 700, lineHeight: '123.5%' },
            h5: { fontSize: '1.5rem', fontWeight: 700, lineHeight: '133.4%' },
            h6: { fontSize: '1.25rem', fontWeight: 700, lineHeight: '160%' },
            h7: { fontSize: '1rem', fontWeight: 700, lineHeight: '175%' },
            h8: { fontSize: '1rem', fontWeight: 700, lineHeight: '175%' },
            subtitle1: { fontSize: '1rem', fontWeight: 400, lineHeight: '175%' },
            subtitle2: { fontSize: '0.875rem', fontWeight: 500, lineHeight: '157%' },
            body1: { fontSize: '1rem', fontWeight: 400, lineHeight: '150%' },
            body2: { fontSize: '0.875rem', fontWeight: 400, lineHeight: '143%' },
            body3: { fontSize: '0.75rem', fontWeight: 400, lineHeight: '143%' },
            caption: { fontSize: '0.75rem', fontWeight: 400, lineHeight: '166%', letterSpacing: '0.025rem' },
            overline: { fontSize: '0.75rem', fontWeight: 400, lineHeight: '266%', letterSpacing: '0.0625rem' },
        },
        components: {
            MuiButton: {
                styleOverrides: {
                    root: {
                        textTransform: 'none',
                        '&.MuiButton-outlinedSuccess': {
                            borderColor: '#01892380',
                        },
                    },
                    sizeMedium: {
                        padding: '0.5rem 1.375rem',
                        backgroundColor: '#018923',
                        borderRadius: '0.25rem',
                        minWidth: 'auto',
                        maxWidth: '16rem',
                        width: 'auto',
                        '&:hover': {
                            backgroundColor: '#01A32D',
                        }
                    },
                },
                variants: [
                    {
                        props: { variant: 'transparent' },
                        style: {
                            backgroundColor: 'transparent',
                            boxShadow: 'none',
                            '&:hover': {
                                backgroundColor: 'transparent',
                                boxShadow: 'none',
                            },
                            '&:active': {
                                backgroundColor: 'backgroundColor: rgba(0, 0, 0, 0.1)',
                                boxShadow: 'none',
                            },
                        },
                    },
                    {
                        props: { variant: 'outlined' },
                        style: {
                            backgroundColor: 'transparent',
                            boxShadow: 'none',
                            '&:hover': {
                                backgroundColor: 'transparent',
                                boxShadow: 'none',
                            },
                            '&:active': {
                                backgroundColor: 'backgroundColor: rgba(0, 0, 0, 0.1)',
                                boxShadow: 'none',
                            },
                        },
                    },
                ],
            },
            MuiTablePagination: {
                styleOverrides: {
                    toolbar: {
                        alignItems: 'baseline',
                    },
                },
            },
            MuiChip: {
                variants: [
                    {
                        props: { color: 'success' },
                        style: {
                            color: '#FFF',
                            backgroundColor: '#007817',
                        },
                    },
                    {
                        props: { color: 'warning' },
                        style: {
                            color: '#FFF',
                            backgroundColor: '#EF6C00',
                        },
                    },
                    {
                        props: { color: 'error' },
                        style: {
                            color: '#FFF',
                            backgroundColor: '#C62828',
                        },
                    },
                    {
                        props: { color: 'info' },
                        style: {
                            color: '#FFF',
                            backgroundColor: '#0288D1',
                        },
                    },
                ],
            },
            MuiIconButton: {
                styleOverrides: {
                    root: {
                        color: '#0000008C'
                    }
                }
            }
        },
    },
    ptBR
);

export default ProduttivoMuiThemeV2;
